import { render, staticRenderFns } from "./BTable.vue?vue&type=template&id=52e615be&scoped=true&"
import script from "./BTable.vue?vue&type=script&lang=js&"
export * from "./BTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e615be",
  null
  
)

export default component.exports